var ctrlopt = ctrlopt,
  site = site || {};

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var city_dropdown_enabled = Drupal.settings.globals_variables.show_city_drop_down_apptbk !== 'undefined' ? Drupal.settings.globals_variables.show_city_drop_down_apptbk : 0;
  var show_country_in_city_dropdown = Drupal.settings.globals_variables.show_country_in_city_dropdown !== 'undefined' ? Drupal.settings.globals_variables.show_country_in_city_dropdown : 0;

  /* Concrete View */
  apptBook.LocationSelectSection = function (container) {
    apptBook.LocationSelectSection.superclass.constructor.call(this);
    this.id = 'counters';
    this.container = container;
    this.selectMenu = container.find('select.location-select');
    this.cityMenu = container.find('select.state-select');
    this.submitBtn = container.find('.location-submit');
    this.signinMessage = container.find('.appt-book-location__signin-text');
    this.boundTransIn = this.onTransIn.bind(this);
    this.initialized = false;
    this.stores = {};
  };

  ctrlopt.extend(apptBook.LocationSelectSection, apptBook.AbstractSection);

  apptBook.LocationSelectSection.prototype.buildCityMenu = function () {
    var me = this;

    if (!this.cityMenu.length) {
      return;
    }
    var optionText = [],
      uniqueCityVals = [];

    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      optionText[i] = show_country_in_city_dropdown ? this.countersData[i].county : this.countersData[i].town;
    }
    $.each(optionText, function (i, el) {
      if ($.inArray(el, uniqueCityVals) === -1) {
        uniqueCityVals.push(el);
        var newOption = $('<option value="' + el + '">' + el + '</option>');

        me.cityMenu.append(newOption);
      }
    });
    $(this.cityMenu).change(function () {
      $(me.selectMenu).find('option').not(':first').remove();
      var select_text = $(me.selectMenu).find('option').html();

      $('ul.location-select-selectBox-dropdown-menu li').not(':first').remove();
      $('ul.location-select-selectBox-dropdown-menu').append('<li class="selectBox-selected">' + '<a rel="' + 0 + '">' + select_text + '</a>' + '</li>');
      me.buildSelectMenu();
    });
  };

  apptBook.LocationSelectSection.prototype.buildSelectMenu = function () {
    var me = this;

    if (!this.countersData || !this.selectMenu.length) {
      return;
    }

    var selected_city = $(this.cityMenu) && $(this.cityMenu).val() != '0' ? $(this.cityMenu).val() : 0;
    var virtualList = [];
    var virtualIds = [];

    for (var i = 0, len = this.model.servicesData.length; i < len; i += 1) {
      if (this.model.servicesData[i].virtual !== '0') {
        virtualList.push(this.model.servicesData[i].id);
      }
    }
    for (var i = 0, len = this.countersData.length; i < len; i += 1) {
      var serviceIds = this.countersData[i].service_ids;

      if (Array.isArray(serviceIds)) {
        virtualIds = serviceIds.filter(function (e) {
          return virtualList.indexOf(e) !== -1;
        });
      }
      var city = show_country_in_city_dropdown ? this.countersData[i].county : this.countersData[i].town;

      if ((!selected_city && typeof virtualIds !== 'undefined' && !virtualIds.length) || (city_dropdown_enabled && (selected_city == city))) {
        var storeName = this.countersData[i].name;

        if (city_dropdown_enabled) {
          var optionText = storeName + ', ' + this.countersData[i].address1;
        } else {
          var optionText = this.countersData[i].town + ' - ' + storeName + ', ' + this.countersData[i].address1;
        }
        var optionValue = this.countersData[i].id,
          newOption = $('<option value="' + optionValue + '">' + optionText + '</option>'),
          ul_newOption = $('<li>' + '<a rel="' + optionValue + '">' + optionText + '</a>' + '</li>'),
          storeNum = this.countersData[i].store_no,
          maxSelections = this.countersData[i].max_appointment_services;

        this.stores[optionValue] = {
          store: storeNum,
          name: storeName,
          maxSelections: maxSelections
        };

        // Don't filter out counters
        this.selectMenu.append(newOption);

        // filter out counters with no services and counters with no calendars
      /* if (this.countersData[i].service_ids.length > 0 && this.countersData[i].calendars.length > 0) {
        this.selectMenu.append(newOption);
      }*/
      }
    }

    function setSubmitBtnState() {
      if (me.selectMenu.val() === '0' || me.cityMenu.val() === '0') {
        me.submitBtn.addClass('disabled');
      } else {
        me.submitBtn.removeClass('disabled');
      }

      return;
    }

    setSubmitBtnState();
    this.selectMenu.on('change', setSubmitBtnState);
  };

  apptBook.LocationSelectSection.prototype.setSubmitHandler = function () {
    var me = this;

    function onSubmit(e) {
      var updateData,
        select = me.selectMenu[0],
        counterId = select.options[select.selectedIndex].value;

      e.preventDefault();

      if ($(this).hasClass('disabled')) {
        return;
      }

      if (counterId) {
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentBooking_Location',
          event_category: 'appointment booking',
          event_action: 'location chosen',
          event_label: me.stores[counterId].store + ' - ' + me.stores[counterId].name
        });
        updateData = {
          sectionId: 'next',
          params: {
            sectionId: me.id,
            counterId: counterId,
            maxSelections: me.stores[counterId].maxSelections,
            updateMode: me.updateMode
          }
        };
        me.model.update(updateData);
      }
    }

    this.submitBtn.click(onSubmit);
  };

  apptBook.LocationSelectSection.prototype.onTransIn = function () {
    var sBoxes = this.container.find('.selectbox');

    site.util.refreshSelectBoxes(sBoxes);
  };

  apptBook.LocationSelectSection.prototype.onUpdate = function (data) {
    var me = this;

    if (data.sectionId === this.id) {
      apptBook.sectionManager.on('transition_in_start', this.boundTransIn);
      me.isSignedIn = typeof site.userInfoCookie == 'undefined'
                            || (typeof site.userInfoCookie.getValue('signed_in') == 'undefined')
                            || (typeof site.userInfoCookie.getValue('signed_in') == 'null')
        ? 0 : site.userInfoCookie.getValue('signed_in');

      if (data.params.updateMode) {
        this.updateMode = true;
      } else {
        this.updateMode = false;
      }
      if (!this.initialized) {
        this.initialized = true;
        this.model.getCounters(function (cData) {
          me.countersData = cData;
          me.buildSelectMenu();
          if (city_dropdown_enabled) {
            me.buildCityMenu();
          }
          if (me.isSignedIn > 0) {
            me.signinMessage.hide();
          }
          me.setSubmitHandler();
        });
      }
    } else {
      apptBook.sectionManager.off('transition_in_start', this.boundTransIn);
    }
  };

  Drupal.behaviors.apptBookLocation = {
    attach: function (context) {
      var view = new apptBook.LocationSelectSection($('#counters'));
      var self = this;

      self.setVirtual('virtual_oab', 0);
      // add class to style for reskin
      $('.appt-book-location-selector', context).find('span').addClass('body-text');
      $('.appt-book-location-selector', context).find('span p').addClass('title--med');
      $('.appt-book-location__signin-text', context).addClass('body-text');

      view.setModel(apptBook.sectionModel).startObserving();
      $('.js-virtual__appointment--btn', context).on('click', function () {
        var storeNumber = $('.appt-book-location-selector', context).attr('data-virtual_store_number');

        self.setVirtual('virtual_oab', 1);
        site?.track?.evtLink && site.track.evtLink({
          event_name: 'appointmentbooking',
          event_category: 'appointment booking',
          event_action: 'start',
          event_label: 'video appointment'
        });
        apptBook.jumpToServicesForStore(storeNumber);
      });
    },
    setVirtual: function (key, value) {
      localStorage.setItem(key, value);
    }
  };
})(jQuery);
